module.exports = __webpack_public_path__ + "img/f_twitter_white.32978efd.svg";